import { Janrain as janrain } from "integration/janrain";

export default janrain;